import React, { useEffect, useState } from 'react';

import Api, { exceptionNotificationAPI } from '../../services/api';
import FormCrud from '../../components/FormCrud';

const AgronomistForm = () => {
  const [TenantOptions, setTenantOptions] = useState([]);
  const userData = JSON.parse(localStorage.getItem('@SoilAnalysis:user'));
  const userTenantID = userData.tenantID;

  const activeOptions = [
    { value: true, text: 'Sim' },
    { value: false, text: 'Não' },
  ];

  const fields = [
    {
      label: 'Nome',
      name: 'name',
      type: 'input',
    },
    {
      label: 'Numero do registro',
      name: 'crea',
      type: 'input',
    },
    {
      label: 'Descrição da função',
      name: 'descriptionFunction',
      type: 'input',
    },
    {
      label: 'Empresa',
      name: 'tenantID',
      type: 'select',
      options: TenantOptions,
    },
    {
      label: 'Ativo',
      name: 'isActive',
      type: 'select',
      options: activeOptions,
    },
  ];

  const loadData = async () => {
    Api.get('Tenant/getAllItems')
      .then(resultTenant => {
        if (resultTenant && resultTenant.data) {
          let options = resultTenant.data.response.map(item => ({
            value: item.tenantID,
            text: item.name,
          }));
          if (userTenantID == null) {
            options = [{ value: '', text: 'Selecione' }, ...options];
          } else {
            options = options.filter(opt => opt.value === userTenantID);
          }
          setTenantOptions(options);
        }
      })
      .catch(error => {
        exceptionNotificationAPI(error);
      });
  };

  useEffect(() => {
    loadData();
  }, []);

  return TenantOptions.length > 0 ? (
    <FormCrud
      formName={'agronomist'}
      title={'Responsável Técnico/Agrônomo'}
      fields={fields}
    />
  ) : (
    <></>
  );
};

export default AgronomistForm;
